import { combineReducers } from "@reduxjs/toolkit";

import { unitGroupsListingReducer } from "./unitGroupsSlice";

export const unitGroupsReducer = combineReducers({
  unitGroupsListing: unitGroupsListingReducer,
});
